import { useEffect, useState } from "react";

declare global {
  interface Window {
    __LegacyApp?: () => JSX.Element;
  }
}

/**
 * Renders the legacy mockup app (Hero/Landing/RegionExplorer/ParcoursList/...).
 * The legacy app routes itself based on window.location.pathname; re-render
 * on popstate so navigations stay in sync.
 */
export default function LegacyFrontoffice() {
  const Legacy = window.__LegacyApp;
  const [, force] = useState(0);

  useEffect(() => {
    const refresh = () => force((n) => n + 1);
    window.addEventListener("popstate", refresh);
    return () => window.removeEventListener("popstate", refresh);
  }, []);

  if (!Legacy) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--ink-mute)",
          fontFamily: "var(--font-body)",
          fontSize: 14,
        }}
      >
        Front-office indisponible.
      </div>
    );
  }
  return <Legacy />;
}
